import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    data: null,
    loading: false,
    error: null,
    lastFetchedAt: null
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        fetchDashboardStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchDashboardSuccess(state, action) {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
            state.lastFetchedAt = Date.now();
        },
        fetchDashboardFail(state, action) {
            state.loading = false;
            state.error = action.payload || 'Failed to load analytics';
        },
        resetDashboard(state) {
            Object.assign(state, initialState);
        }
    }
});

export const {
    fetchDashboardStart,
    fetchDashboardSuccess,
    fetchDashboardFail,
    resetDashboard
} = dashboardSlice.actions;

export default dashboardSlice.reducer;